import { HttpClient, HttpHeaders, HttpParameterCodec, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SessionStorageService } from 'ngx-webstorage';
import { environment } from '../../../environments/environment';

@Injectable()
export class OtpService {

  private url: string;// = environment.apiOTP;
  private httpHeaders: any;

  constructor(
  	public http: HttpClient,
    private _sessionStorage: SessionStorageService
  ) { 
    this.httpHeaders = this.getHeaders();
    this.url = this.getUrlEnvironment();
  }

  getConsumirOtp(body: any, otp: any): Observable<any> {
    if (!this.httpHeaders) this.httpHeaders = this.getHeaders();
    return this.http.put(`${this.url}/identidad/2fa/v1/otps/${otp}/consumir`, body, { headers: this.httpHeaders });
  }
  
  getConsultarOtp(id: string, otp: any): Observable<any>{
    //this.url = 'https://apidesarrolloazure.dian.gov.co'
    if (!this.httpHeaders) this.httpHeaders = this.getHeaders();
    return this.http.get(`${this.url}/identidad/2fa/v1/otps/${otp}?userId=${id}`,  { headers: this.httpHeaders });
  }

  private getHeaders(): any {    
    const storageToken = this._sessionStorage.retrieve('MUISCATK');
    if (storageToken) {
      return {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + storageToken.token.idToken,
        "clientId": storageToken.token.clientId
      }; 
    } else return null;       
  }

  private getUrlEnvironment(): string {
    const url = window.location.origin;
    if (url.indexOf('pruebas') > -1) return environment.apiOTPPruebas;
    else if (url.indexOf('localhost') > -1) return environment.apiOTPDev;
    else return environment.apiOTPProd;
  }
}


// WEBPACK FOOTER //
// C:/Users/whuerfanoh/Documents/VSCode Projects/ng_identidadlogin/webapp/src/app/resources/services/otp.service.ts